import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';

interface RequireRoleProps {
  roles: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function RequireRole({ roles, children, fallback }: RequireRoleProps) {
  const { user, isCustomerAdmin } = useAuthStore();

  const hasRole = roles.some(role =>
    user?.roles?.includes(role) || user?.roles?.includes('GlobalAdmin')
  );

  // CustomerAdmin/ProgramAdmin from auth store (customer_user.is_admin)
  const hasAdminAccess = isCustomerAdmin && roles.some(role =>
    ['CustomerAdmin', 'ProgramAdmin'].includes(role)
  );

  if (!hasRole && !hasAdminAccess) {
    return fallback ? <>{fallback}</> : <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default RequireRole;
